/**
 * Nova compatibility gate — verbatim from v1 nova_currency.js (research/06
 * §3; REQ-CUR-1): full `window.baCurr` structural check AND
 * (`enableCurrencyConversion === true` from the localStorage config OR the
 * hardcoded href substring whitelist).
 *
 * bare $ = BUNDLED jQuery.
 */
import $ from "jquery";

export function IsNovaCurrencyCompatible(): boolean {
    var cpc_config = parseJSON(localStorage.getItem("cpc_configData"), {}) || {};
    return (
        window.baCurr &&
        window.baCurr.config &&
        window.baCurr.Currency &&
        window.baCurr.Currency.rates &&
        Object.keys(window.baCurr.Currency.rates).length > 0 &&
        ((cpc_config?.enableCurrencyConversion === true) ||
        (($(location as any).attr("href") as any).indexOf("cpc-qa") > 0 || ($(location as any).attr("href") as any).indexOf("unikportrait") > 0 || ($(location as any).attr("href") as any).indexOf("awspainting") > 0 || ($(location as any).attr("href") as any).indexOf("stickerprint") > 0))
    );
}

function parseJSON(inputString: any, fallback: any): any {
    if (inputString) {
        try {
            return JSON.parse(inputString);
        } catch (e) {
            return fallback;
        }
    }
}
